import { render, staticRenderFns } from "./ObjectObstructionsItem.vue?vue&type=template&id=38074b64&scoped=true"
import script from "./ObjectObstructionsItem.vue?vue&type=script&lang=js"
export * from "./ObjectObstructionsItem.vue?vue&type=script&lang=js"
import style0 from "./ObjectObstructionsItem.vue?vue&type=style&index=0&id=38074b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38074b64",
  null
  
)

export default component.exports